import Google from "../assets/google.jpg";
import Verizon from "../assets/verizon.jpg";
import ProjectImg from "../assets/project.jpg";
import AspNetProjectImg from "../assets/aspnetproject.jpg";
import OngbauApi from "../assets/ongbau-api-endpoints.png";
import OngbauClient from "../assets/ongbau-client.png";

interface Map {
  [key: string]: string | undefined;
}

// google : Google
// google - company name mentioned in Experience.json (lower cased)
// Google - imported nam
export const logo: Map = {
  google: Google,
  verizon: Verizon,
};

export enum Constants {
    USERNAME = "Nguyễn Hữu Anh Tuấn",
    GithubLink = "https://github.com/entykey"
}

// "project name 1": ProjectImg
// "project name 1" - project name mentioned in Projects.json ( changed lower cased)
// ProjectImg - imported name 
export const projectImage: Map = {
  "react (client) for asp.net ongbau ordering api": OngbauClient,
  "(server) asp.net ongbau ordering api": OngbauApi,
  "asp.net book share app": AspNetProjectImg,
  "project name 2": ProjectImg,
};
